import APIV5 from '~/models/api';
import WorkflowAffect from '~/scripts/services/model/workflow-affect';

export default class WorkflowService {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 */
	constructor($injector) {
		this.$injector = $injector;
	}
	/**
	 * @param {import('@knitiv/api-client-javascript').KNode} node
	 * @param {'open' | 'close' | undefined} [id]
	 * @returns {Promise<any[]|{close:any[],open:any[]}>}
	 */
	async nodeAffectList(node, id = undefined) {
		const wfList = await APIV5.instance.wfNodeAffectList({ node }, { id: 'workflow-service.node-affect-list' });
		if (!id) {
			return {
				close: wfList.list_close.map((/** @type {any} */ a) => new WorkflowAffect(this.$injector, a)),
				open: wfList.list_open.map((/** @type {any} */ a) => new WorkflowAffect(this.$injector, a)),
			}
		}
		return wfList && (
			id === 'open'
				? wfList.list_open.map((/** @type {any} */ a) => new WorkflowAffect(this.$injector, a))
				: wfList.list_close.map((/** @type {any} */ a) => new WorkflowAffect(this.$injector, a))
		);
	}
}
